import { User } from '../services/auth.service';

const INITIAL_STATE: User = {
  id: 0,
  grantType: '',
  features: [],
  featuresCodes: [],
  companyId: 0,
  defaultContact: 0,
  contactId: 0,
  fullName: '',
  timeZone: '',
  userName: '',
  userType: 0,
  emailAddresses: [],
  shippingVendorId: 0,
  manufacturers: [],
  showTutorial: 0,
  shopId: 0,
  firstName: '',
  lastName: '',
  companyName: '',
  userGuid: '',
  marketId: 0,
  opsUserId: 0,
  isProxyLogin: false,
};

const CURRENT_USER = 'CURRENT_USER';
export const CurrentUserActions = {
  INIT: `${CURRENT_USER}.CURRENT_USER.INIT`,
  SET_USERNAME: `${CURRENT_USER}.SET_USERNAME`,
  SET_USER: `${CURRENT_USER}.SET_USER`,
  SET_CFID: `${CURRENT_USER}.SET_CFID`,
};

export function currentUserReducer(state: User = INITIAL_STATE, action: any) {
  switch (action.type) {
    case CurrentUserActions.INIT:
      state = INITIAL_STATE;
      return state;
    case CurrentUserActions.SET_USER:
      state = action.payload;
      return state;
    case CurrentUserActions.SET_USERNAME:
      state.userName = action.payload;
      return state;
    case CurrentUserActions.SET_CFID:
      state.cfid = action.payload;
      return state;
    default:
      return state;
  }
}
